<template>
  <div class="w-100 h-100">
    <div class="warnList">
      <div class="container">
        <h2 style="font-size: 20px;">设备列表</h2>
        <a-space>
          <a-range-picker :defaultValue="defaultRange" @change="onDateChange"/>
          <a-select v-model="q" style="width: 100px;">
            <a-select-option value="1">
              未读
            </a-select-option>
            <a-select-option value="2">
              已读
            </a-select-option>
          </a-select>
          <a-button type="primary" @click="getTableList">查询</a-button>
        </a-space>
      </div>
      <a-table
        :columns="columns"
        :data-source="data"
        :rowKey="record => record.id"
        :loading="loading"
        :pagination="pagination"
        @change="handleTableChange"
      >
        <template v-slot:operation="text, record">
          <a type="link" :disabled="record.status === '已读'" style="margin-right: 12px" @click="notice(record.id)">已读</a>
          <a type="link" @click="showModel(record.id)">删除</a>
        </template>
      </a-table>
    </div>
    <a-modal
      title="删除预警"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="removeWarningRecord"
      @cancel="visible = false"
    >
      <p>确认要删除吗？</p>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import warningApi from '@/api/warning'
import { getWarningRecordList, noticeWarningRecord, deleteWarningRecord } from '@/api/warning'

const level = {
  URGENT: '紧急',
  IMPORTANT: '重要',
  MINOR: '次要',
  PROMPT: '提示'
}

export default {
  data() {
    return {
      defaultRange: [],
      q: '1',
      columns: [
        {
          title: '预警级别',
          dataIndex: 'warningLevel',
          key: 'warningLevel'
        },
        {
          title: '预警名称',
          dataIndex: 'warningName',
          key: 'warningName'
        },
        {
          title: '通知内容',
          dataIndex: 'noticeContent',
          key: 'noticeContent'
        },
        {
          title: '创建时间',
          dataIndex: 'createdAt',
          key: 'createdAt'
        },
        {
          title: '预警状态',
          dataIndex: 'status',
          key: 'status'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          key: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      data: [],
      loading: false,
      visible: false,
      confirmLoading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created () {
    const nowDate = new Date()
    this.startTime = nowDate - 30 * 24 * 3600 * 1000
    this.endTime = +nowDate
    this.defaultRange = [
      moment(new Date(this.startTime), 'YYYY-MM-DD HH:mm:ss'),
      moment(nowDate, 'YYYY-MM-DD HH:mm:ss')
    ]
    this.getTableList()
  },
  methods: {
    onDateChange (d) {
      this.startTime = new Date(d[0]._d.toLocaleDateString()).getTime()
      this.endTime = new Date(d[1]._d.toLocaleDateString()).getTime() + 24 * 3600 * 1000 - 1
    },
    async getTableList () {
      this.loading = true
      try {
        const { startTime, endTime } = this
        const { data } = await getWarningRecordList({
          startTime,
          endTime
        })
        // this.data = data.map(item => {
        //   item.createdAt = moment(+item.createdAt).format('YYYY-MM-DD HH:mm:ss ddd')
        //   item.warningLevel = level[item.warningLevel]
        //   item.status = item.notices[0].isRead ? '已读' : '未读'
        //   return item
        // })
        // this.pagination.current = data.current
        // this.pagination.total = data.total
        let list = []
        if (this.q === '1') {
          data.forEach(item => {
            if (!item.notices[0].isRead) {
              item.createdAt = moment(+item.createdAt).format('YYYY-MM-DD HH:mm:ss ddd')
              item.warningLevel = level[item.warningLevel]
              item.status = '未读'
              list.push(item)
            }
          })
        }
        if (this.q === '2') {
          data.forEach(item => {
            if (item.notices[0].isRead) {
              item.createdAt = moment(+item.createdAt).format('YYYY-MM-DD HH:mm:ss ddd')
              item.warningLevel = level[item.warningLevel]
              item.status = '已读'
              list.push(item)
            }
          })
        }
        this.data = list
      } catch(err) {
        console.error(err)
      } finally {
        this.loading = false
      }
    },
    handleTableChange (pagination) {
      this.pagination = pagination
      this.getTableList()
    },
    async notice (id) {
      try {
        const { message } = await noticeWarningRecord(id)
        this.$message.success(message)
        this.getTableList()
      } catch (err) {
        console.error(err)
      }
    },
    showModel (id) {
      this.id = id
      this.visible = true
    },
    async removeWarningRecord () {
      this.confirmLoading = true
      try {
        const { message } = await deleteWarningRecord(this.id)
        this.$message.success(message)
        this.visible = false
        this.getTableList()
      } catch (err) {
        console.error(err)
      } finally {
        this.confirmLoading = false
      }
    }
  }
}
</script>

<style scoped>
.warnList {
  width: 100%;
  height: 100%;
  padding: 15px;
}
.warnList .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  font-size: 20px;
}
</style>